import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import styled from 'styled-components';

import AppContext from '../context/AppContext';
import bg from '../assets/images/bg.jpg';
import icon from '../assets/images/log.png';
export default function Connect() {
  const { connectWallet, theme, isLoggedIn, hasLoaded, isMember } =
    useContext(AppContext);
  const navigate = useNavigate();
  console.log('CHECKING ISLOGGEDIN AND ISMEMBER CONNECT', isLoggedIn, isMember);
  useEffect(() => {
    if (hasLoaded) {
      if (isLoggedIn && isMember) {
        navigate('/');
      } else if (!isLoggedIn) {
      } else {
        navigate('/create-profile');
      }
    }
  }, [isLoggedIn, isMember, hasLoaded]);

  return (
    <StyledConnect theme_={theme} img={bg}>
      <div className="left">
        <img src={icon} alt="img" />
        <h1>VoiceDAO</h1>
      </div>
      <div className="right">
        <h2>An amazing Decentralized organization</h2>
        <span>
          {' '}
          <button onClick={() => connectWallet()}>Connect Wallet </button>
        </span>
      </div>
      <div className="mob-right">
        <img src={icon} alt="img" />
        <h1>SpeakOut</h1>
      </div>
    </StyledConnect>
  );
}

const StyledConnect = styled(motion.div)`
  display: flex;
  flex-direction: row;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background: ${({ theme_ }) => (theme_ ? '#0f0f0f' : '#ffffff')};
  @media screen and (max-width: 900px) {
    flex-direction: column;
  }
  button {
    padding: 1rem;
    cursor: pointer;
  }
  .left {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
    width: 50%;
    img {
      width: 30%;
    }
    h1 {
      color: white;
    }
    background-image: url(${({ img }) => img});
    @media screen and (max-width: 900px) {
      width: 100%;
      display: none;
    }
  }
  .right {
    display: flex;
    width: 50%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    @media screen and (max-width: 900px) {
      width: 100%;
    }
  }
  .mob-right {
    display: none;
    height: 100%;
    background-image: url(${({ img }) => img});
    justify-content: center;
    align-items: center;
    img {
      width: 30%;
    }
    flex-direction: column;
    gap: 0.5rem;
    h1 {
      color: white;
    }

    @media screen and (max-width: 900px) {
      display: flex;
    }
  }
`;
